export const translations = {
  sv: {
    preamble: 'E-handelstransport',
    text: 'Vi erbjuder Svanenmärkta leveranser av e-handelspaket',
  },
  en: {
    preamble: 'E-commerce transport',
    text: 'We offer Nordic Ecolabelled deliveries of e-commerce packages',
  },
  da: {
    preamble: 'E-handel transport',
    text: 'Vi tilbyder svanemærkede leveringer af e-handelspakker',
  },
  no: {
    preamble: 'E-handelstransport',
    text: 'Vi tilbyr svanemerkede leveranser av e-handelspakker',
  },
  fi: {
    preamble: 'Sähköisen kaupankäynnin kuljetus',
    text: 'Tarjoamme pohjoismaisia ​​Joutsenmerkittyjä verkkokaupan pakettien toimituksia',
  },
};
